module.exports = __webpack_public_path__ + "static/media/cor.79bb3661.jpeg";